import React, { FC, useEffect } from 'react';
import { useStore } from '../../store/store-provider';


const QandASubscriptionHOC: FC = ({ children }):JSX.Element => {
  const { questionStore, podiumInfoStore } = useStore();
  const {
    onCreateQuestionSubscription,
    onUpdateQuestionSubscription,
    onBatchQuestionsUpdate,
  } = questionStore;

  const { getPresentationId } = podiumInfoStore;

  useEffect(() => {

    if (!getPresentationId()) return;

    const onCreateQuestion = onCreateQuestionSubscription();
    const onUpdateQuestion = onUpdateQuestionSubscription();
    const onBatchUpdateQuestion = onBatchQuestionsUpdate();

    return () => {
      onBatchUpdateQuestion.unsubscribe();
      onCreateQuestion.unsubscribe();
      onUpdateQuestion.unsubscribe();
    };
  }, []);

  return <>{children}</>;
};

export default QandASubscriptionHOC;
